/**
 * Tenants Module Configuration
 *
 * Standalone CRM module for managing property tenants — businesses
 * discovered at or associated with a property's physical address.
 * Supports discovery via Google Places, CRUD, and Apollo sync.
 *
 * @see FRONT-END-PROPERTY-TENANTS.md for product documentation
 */

import type { AppModule } from '@/types/architecture'
import routes from './routes'

const tenantsModule: AppModule = {
    id: 'tenants',

    navigation: {
        label: 'Tenants',
        icon: 'home',
        path: '/tenants',
        order: 25,
        showInSidebar: false,


        pages: [
            {
                label: 'All Tenants',
                path: '/tenants',
            },
        ],
    },

    routes,
}

export default tenantsModule
